export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Romantic%20couple%20sitting%20closely%20together%20on%20a%20plush%20velvet%20sofa%20in%20a%20dimly%20lit%20home%20theater%20room%2C%20warm%20golden%20ambient%20lighting%20from%20string%20lights%20and%20candles%2C%20large%20screen%20with%20soft%20glow%2C%20intimate%20cozy%20atmosphere%2C%20cinematic%20composition%2C%20soft%20bokeh%20background%2C%20warm%20rose%20and%20amber%20tones%2C%20editorial%20photography%20style%20with%20shallow%20depth%20of%20field%2C%20elegant%20and%20sophisticated%20mood&width=1600&height=900&seq=hero-couple-cinema-01&orientation=landscape"
          alt="夫妻影院浪漫观影氛围 - 温馨二人世界电影之夜"
          className="w-full h-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/55"></div>

      <div className="relative z-10 w-full mx-auto px-4 md:px-6 max-w-[1280px]">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left pt-20 md:pt-24 pb-6 lg:pb-0">
            <div className="inline-flex items-center gap-2 bg-primary-500/20 backdrop-blur-sm border border-primary-400/30 rounded-full px-4 py-1.5 mb-6">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-heart-pulse-line text-sm text-primary-300"></i>
              </div>
              <span className="text-xs md:text-sm font-medium text-primary-100 tracking-wide whitespace-nowrap">
                浪漫电影推荐 · 夫妻情侣专属
              </span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-5">
              夫妻影院
              <span className="block text-xl md:text-2xl lg:text-3xl font-normal text-white/80 mt-2">
                二人世界的浪漫光影之旅
              </span>
            </h1>

            <p className="text-sm md:text-base text-white/70 leading-relaxed max-w-[580px] mx-auto lg:mx-0 mb-8">
              夫妻影院致力于为每一对夫妻和情侣精心甄选适合共同观看的高清影视内容。从经典爱情片到最新浪漫电影推荐，覆盖二人世界电影全品类，免费高清在线观看不缓冲，让每一次观影都成为感情升温的美好时刻。本站每日更新夫妻必看影视高清在线全集，打造专属的温馨观影体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-5 md:gap-8 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">2000+</div>
                <div className="text-xs text-white/50 mt-1">精选影片</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">每日更新</div>
                <div className="text-xs text-white/50 mt-1">内容节奏</div>
              </div>
              <div className="w-px h-10 bg-white/15 hidden sm:block"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">高清流畅</div>
                <div className="text-xs text-white/50 mt-1">不缓冲体验</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#cards"
                onClick={(e) => { e.preventDefault(); document.querySelector('#cards')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 bg-primary-500 hover:bg-primary-600 text-white font-semibold px-7 py-3 rounded-full text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-play-circle-line"></i>
                </span>
                开始探索精选
              </a>
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' }); }}
                className="inline-flex items-center gap-2 border border-white/30 hover:border-white/60 text-white font-medium px-7 py-3 rounded-full text-sm transition-all duration-300 cursor-pointer whitespace-nowrap"
              >
                <span className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-information-line"></i>
                </span>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-[480px] lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-primary-500/10 rounded-3xl blur-3xl"></div>
              <div className="relative rounded-2xl overflow-hidden border border-white/15">
                <img
                  src="https://readdy.ai/api/search-image?query=Elegant%20romantic%20couple%20watching%20a%20classic%20film%20together%20in%20an%20intimate%20home%20cinema%20setting%2C%20warm%20candlelight%20glow%2C%20cozy%20blanket%20over%20their%20laps%2C%20popcorn%20bowl%20nearby%2C%20soft%20ambient%20warm%20lighting%2C%20vintage%20movie%20poster%20aesthetic%2C%20cinematic%20mood%2C%20rich%20crimson%20and%20gold%20accents%2C%20sophisticated%20editorial%20photography&width=900&height=1200&seq=hero-couple-movie-02&orientation=portrait"
                  alt="夫妻影院 - 情侣共同观赏浪漫电影温馨时刻"
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}